module.exports = __webpack_public_path__ + "static/media/Liberator.e18e477f.svg";